import { render, staticRenderFns } from "./InvestorMerchantContract.vue?vue&type=template&id=b57b2ab6&scoped=true"
import script from "./InvestorMerchantContract.vue?vue&type=script&lang=js"
export * from "./InvestorMerchantContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57b2ab6",
  null
  
)

export default component.exports